var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSauceIcon = function SvgSauceIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 9.625V7.562a.687.687 0 00-.688-.687h-1.526l-1.223-4.978A.687.687 0 0011 1.375a.687.687 0 00-.688.515L9.049 6.875H7.561a.688.688 0 00-.687.687v2.063h8.25zM15.125 11h-8.25a.687.687 0 00-.688.688v8.25c0 .38.308.687.688.687h8.25c.38 0 .688-.308.688-.688v-8.25a.687.687 0 00-.688-.687z",
    fill: "#004CCC"
  })));
};

export default SvgSauceIcon;